import { Divider, Icon, List, ListItem, ListItemIcon, ListItemText, makeStyles, Typography } from "@material-ui/core";
import {
  AddOutlined,
  BallotOutlined,
  BarChartOutlined,
  HomeOutlined,
  MapOutlined,
  MessageOutlined,
  PeopleOutlined,
  PersonOutlined,
} from "@material-ui/icons";
import React, { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { selectUser } from "../../features/data/user/userSlice";
import { useSelector, shallowEqual } from "react-redux";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    ...theme.mixins.toolbar,
    display: "flex",
    alignItems: "center",
    padding: 10,
  },
}));

const DrawerList = (props) => {
  const { onClose } = props;
  const classes = useStyles();
  const location = useLocation();

  const { user } = useSelector(selectUser, shallowEqual);
  const drawerItems = [
    {
      name: "داشبورد",
      link: "/panel/dashboard",
      icon: <BarChartOutlined />,
    },
    ...(user?.role !== "read_only"
      ? [
          {
            name: "ارزیابی جدید",
            link: "/panel/valuations/new",
            icon: <AddOutlined />,
          },
        ]
      : []),
    {
      name: "ارزیابی‌ها",
      link: "/panel/valuations",
      icon: <BallotOutlined />,
    },
    // {
    //   name: "نقشه",
    //   link: "/panel/map",
    //   icon: <MapOutlined />,
    // },
    ...(user?.role === "user" || user?.role === "admin" || user?.role === "read_only"
      ? [
          {
            name: "پیام‌ها",
            link: "/panel/messages",
            icon: <MessageOutlined />,
          },
        ]
      : []),
    {
      name: "حساب کاربری",
      link: "/panel/profile",
      icon: <PersonOutlined />,
    },
  ];

  return (
    <Fragment>
      <div className={classes.toolbar}>
        <Icon color='primary' style={{ marginRight: 15 }}>
          <HomeOutlined color='secondary' />
        </Icon>
        <Typography noWrap style={{ marginRight: 30, fontSize: 20, fontWeight: "800" }}>
          مشاورین املاک
        </Typography>
      </div>

      {/* <Divider /> */}
      <List style={{ padding: 10 }}>
        {drawerItems.map((item) => (
          <ListItem
            button
            key={item.name}
            component={Link}
            to={item.link}
            selected={location.pathname === item.link}
            onClick={onClose}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.name} />
          </ListItem>
        ))}

        {user?.role === "admin" && (
          <ListItem
            button
            key='کاربران سایت'
            component={Link}
            to={`/panel/users`}
            selected={location.pathname === "/panel/users"}
            onClick={onClose}
          >
            <ListItemIcon>
              <PeopleOutlined />
            </ListItemIcon>
            <ListItemText primary='کاربران سایت' />
          </ListItem>
        )}
      </List>

      {/* <Divider /> */}
      {/* <List style={{ padding: 10 }}>
          <ListItem
            button
            key='نقشه'
            component={Link}
            to={`/panel/map`}
            selected={location.pathname === "/panel/map"}
            onClick={() => setMobileOpen(false)}
          >
            <ListItemIcon>
              <MapOutlined />
            </ListItemIcon>
            <ListItemText primary='نقشه' />
          </ListItem>
        </List> */}
    </Fragment>
  );
};

export default DrawerList;
